// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/fonts/Brightstar_Sans/BrightstarSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/assets/fonts/Brightstar_Sans/BrightstarSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--dust-white);
  height: 100%;
}

:root {
  --dust-white: #F7EDE5;
  --betel-orange:  #FF7A00;
  --vega-blue: #002EE5;
  --aldebaran-yellow: #FCCF0D;
  --reach-blue: #050533;
  --arcturus-red: #E73443;
  --canopus-violet: #B379F6;
   --procyon-green: rgb(84, 242, 163)
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.modal-backdrop
{
    --bs-backdrop-bg: rgb(0 0 0 / 30%) !important;
}

@font-face {
  font-family: 'BrightstarSans-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}

@font-face {
  font-family: 'BrightstarSans-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;GACxB;AACH;;AAEA;EACE;aACW;AACb;;AAEA;;IAEI,6CAA6C;AACjD;;AAEA;EACE,qCAAqC;EACrC,+DAA6F;AAC/F;;AAEA;EACE,kCAAkC;EAClC,+DAA0F;AAC5F","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--dust-white);\n  height: 100%;\n}\n\n:root {\n  --dust-white: #F7EDE5;\n  --betel-orange:  #FF7A00;\n  --vega-blue: #002EE5;\n  --aldebaran-yellow: #FCCF0D;\n  --reach-blue: #050533;\n  --arcturus-red: #E73443;\n  --canopus-violet: #B379F6;\n   --procyon-green: rgb(84, 242, 163)\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.modal-backdrop\n{\n    --bs-backdrop-bg: rgb(0 0 0 / 30%) !important;\n}\n\n@font-face {\n  font-family: 'BrightstarSans-Regular';\n  src: url('../src/assets/fonts/Brightstar_Sans/BrightstarSans-Regular.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'BrightstarSans-Bold';\n  src: url('../src/assets/fonts/Brightstar_Sans/BrightstarSans-Bold.otf') format('opentype');\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
